<template>
<div class="selectBC">
  <div v-if="isShow" class="">
    <Flow v-bind:step="1"/>
    <div class="contents bg_white mt12 pt16">
      <h2 class="content_title">BC選択</h2>
      <form class="form" action="" method="post">
        <div class="select_wrap">
          <select class="select_bc rb" name="bc_number" v-model="nowBC">
            <option>BCを選択してください</option>
            <option v-for="index in bcList" v-bind:value="index" :key="index">{{ index }}</option>
          </select>
        </div>
        <a href="#" class="btn_blue" @click.stop.prevent="setBC()">次へ</a>
      </form>
      <button type="button" name="button" @click="closeWebView()" onClick="android.close()" class="back btn_delete">戻る</button>

    </div>
  </div>
  <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</div>
</template>

<script>
import Flow from '@/components/subscription/Flow'
import Bc from '@/components/api/bc'
import Check from '@/model/getToken'
import close from '@/model/closeWebView'

export default {
  components: {
    Flow
  },
  data() {
    return {
      isShow: true,
      bcList: [],
      nowBC: '',
      selectBC: []
    }
  },
  methods: {
    closeWebView() {
      close.closeWebView();
    },
    setSubscriptionNowBC(bc) {
      this.$store.commit('setSubscriptionNowBC', bc);
    },
    async defaultBC() {
      Bc.bcList().then((val) => {
        for (var i = 0; i < val.bcNoList.length; i++) {
          this.bcList.push(val.bcNoList[i]);
        }
        this.setNowBC();
      });
    },
    setBC() {
      if(this.nowBC == '')  return;
      localStorage.setItem('subNowBC', this.nowBC);
      this.setSubscriptionNowBC(this.nowBC);
      this.$router.push({ name: 'subSelectProducts', params: {subNowBC: this.nowBC }});
    },
    setNowBC() {
      let nowBC = localStorage.getItem('subNowBC');
      if(nowBC != null) {
        this.nowBC = nowBC;
      } else {
        this.nowBC = this.bcList[0];
      }
      this.setSubscriptionNowBC(this.nowBC)
    },
    strageClear() {
      localStorage.removeItem('userDetail');
      localStorage.removeItem('simulateResponse');
      localStorage.removeItem('subNowBC');
      localStorage.removeItem('repeatItemList');
      localStorage.removeItem('existRepeatItem');
      localStorage.removeItem('addressSelectNumber');
      this.$store.commit('setSubscriptionDenyCreditDeliveryFlag', null);
    },
  },
  async created() {
    this.strageClear();

    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      this.defaultBC();
    } else {
      this.isShow = false;
    }
  }
}
</script>

<style lang="css" scoped>
.back {
  margin-top: 25px;
}
select {
  -webkit-appearance: none;
  appearance: none; /* デフォルトのスタイルを無効 */
}

select::-ms-expand {
  display: none; /* デフォルトのスタイルを無効(IE用) */
}

.content_title {
  width: 94px;
}

.select_bc {
  border: none;
  border-bottom: 1px solid #c9c9c9;
  color: #5a5a5a;
  font-size: 40px;
  margin-top: 17px;
  padding: 0 16px 10px;
  width: 100%;
}

.select_wrap {
  position: relative;
}

.select_wrap::after {
  content: '\f078';
  color: #636366;
  font-size: 18px;
  font-family: "Font Awesome 5 Free","Font Awesome 5 Brands";
  font-weight: 900;
  margin-right: 4px;
  position: absolute;
  right: 17px;
  top: 59%;
}
.btn_blue {
  margin-top: 56px;
}
/* .btn_blue {
  margin-top: 56px;
} */
</style>



// WEBPACK FOOTER //
// src/views/subscription/SubSelectBC.vue